import React from 'react';
import { Modal, Row } from 'react-bootstrap';
import { Button } from '../../../form/FormControls.jsx';
import { connect } from 'react-redux';
import ConnectLink from './ConnectLink.jsx';
import { getDealListWrapper } from '../store/DealsWrapper.js';
import { alterProduct, removeDealExpense } from '../store/deal.store.js';
import { handleFormChanged } from '@/store/allaround.store.js';
import RegNumberElement from '../elements/RegNumberElement';
import CompositeProductElement from '../elements/CompositeProductElement';
import { addFromTab } from '../../../../util/util.jsx';
import ConnectDealElement from './ConnectDealElement';
import { linkExisting } from '@/store/links.store';
import { Map, List } from 'immutable';
import { deleteFile } from '../store/files.store';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import { REF_PATH as EXPENSES_TYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';
import unlink from '../../../../../style/unlink.png';


class Link extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.addTransport = this.addTransport.bind(this);
    this.delTransport = this.delTransport.bind(this);
    this.linkExisting = this.linkExisting.bind(this);
    this.state = { showModal: false,
      hidden: false,
      data: undefined,
      transport: undefined };
  }

  componentWillMount() {
    if (!this.props.linkDealsList) {
      getDealListWrapper(this.props.fromType, 'INF');
      getDealListWrapper(this.props.toType, 'INF');
    }
    if (!this.props.linkTransportList) {
      getDealListWrapper('transport', 'INF');
    }
    if (this.props.defaultValue && this.props.defaultValue.get('hidden')) {
      this.setState({ hidden: true });
    } else if (this.props.linkDealsList && this.props.defaultValue) {
      this.createDisplayData(this.props);
    }
  }

  componentWillReceiveProps(props) {
    if (!props.linkDealsList) {
      getDealListWrapper(props.toType, 'INF');
    }
    if (props.defaultValue && props.defaultValue.get('hidden')) {
      this.setState({ hidden: true, data: undefined });
    } else if (props.linkDealsList && props.fromTypeList && props.defaultValue &&
      (props.defaultValue != this.props.defaultValue ||
         props.linkDealsList != this.props.linkDealsList
       || props.fromTypeList != this.props.fromTypeList
       || props.product != this.props.product)) {
      this.createDisplayData(props);
    }
  }
  shouldComponentUpdate(nextProps) {
    if (!nextProps.linkDealsList || !nextProps.defaultValue) {
      return false;
    }
    return true;
  }
  linkExisting() {
    this.props.linkExisting();
  }
  openModal(e) {
    e.stopPropagation();
    this.setState({ showModal: true });
  }
  closeModal() {
    this.setState({ showModal: false });
  }
  yesButton() {
    const links = this.props.product.get(`${this.props.fromType}Link`);
    const link = links.get(this.props.idx)
      .set(`${this.props.toType}Id`, undefined)
      .set(`${this.props.toType}Packing`, undefined)
      .set(`${this.props.toType}ProductType`, undefined)
      .set(`${this.props.toType}Product`, undefined);
    this.props.alterProduct(this.props.product
      .set(`${this.props.fromType}Link`, links.set(this.props.idx, link)
      )
    );
    this.setState({ showModal: false });
    this.props.handleFormChanged();
  }

  addTransport(transport) {
    this.setState({ transport });
  }
  delTransport() {
    this.setState({ transport: null });
  }

  createDisplayData(props) {
    const data = props.defaultValue;
    let linkedDeal = undefined;
    let linkedProduct = undefined;
    if (props.linkDealsList) {
      linkedDeal = props.linkDealsList
        .find(deal => deal.get('id') == data.get(`${props.toType}Id`));
      linkedProduct = linkedDeal && linkedDeal.get('products') ?
        linkedDeal.get('products')
          .find(product => product.get('id') ==
      props.defaultValue.get(`${props.toType}Product`))
        : undefined;
    }
    const header = () => (
      <Row className={'link-header'}>
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
          <RegNumberElement
            data={linkedDeal}
            type={props.toType}
          />
        </div>
        <div style={{ paddingTop: 5, paddingBottom: 5, marginLeft: 'auto' }}>
          {props.disabled || props.viewMode ? '' :
            <Button
              id="deleteLink"
              bsStyle="link"
              style={{ float: 'right', padding: '2px 5px 2px 3px' }}
              onClick={this.openModal}
            >
              <img src={unlink} alt={'Unlink'} className={'unlink-icon'} />
            </Button>
          }
        </div>
      </Row>);

    const component = !linkedDeal ?
      <Row className={'link-deal-to-half-link'}>
        {!props.disabled && !props.viewMode && !props.isArchived ?
          <ConnectDealElement
            linkExisting
            startAtomsLinking={this.linkExisting}
            buttonStyle={{ float: props.fromType == 'sale' ? 'right' : 'left' }}
          /> : ''}
      </Row> :
      <Row>
        <CompositeProductElement
          url={`/deals/${props.toType}/${data.get(`${props.toType}Id`)}${addFromTab()}`}
          allowUrl={validateRoleConfig(['myDeals#1', 'allDeals#1'], linkedDeal)}
          header={header}
          data={data} dealEditMode={!props.viewMode}
          elem={linkedProduct} hideLinks dealType={props.toType}
          dealIdx={props.dealIdx}
          linkIdx={props.idx}
          idx={props.productIdx}
          disabled={props.disabled}
        />
      </Row>;
    const dataToDisplay = (<div
      style={{ display: this.state.defaultHidden ? 'none' : '',
        marginBottom: props.isLast ? 0 : 5 }}
    >
      <ConnectLink
        transport={this.props.transport}
        defaultValue={data}
        product={props.product}
        productIdx={props.productIdx}
        linkIdx={props.idx}
        fromType={props.fromType}
        toType={props.toType}
        viewMode={props.viewMode || props.disabled}
        disabled={props.disabled}
        fromMultiNodal={this.props.fromMultiNodal}
      >
        {component}
      </ConnectLink>
    </div>);
    this.setState({ data: dataToDisplay });
  }

  render() {
    return (this.state.data ? <div id={this.props.id}>
      <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal} >
        <Modal.Body>
          Are you sure you want to delete the link?
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.yesButton}>Yes</Button>
          <Button onClick={this.closeModal}>No</Button>
        </Modal.Footer>
      </Modal>
      {this.state.data}
    </div> : <div />);
  }
}
Link.propTypes = {
  defaultValue: React.PropTypes.object,
  label: React.PropTypes.string,
  isArchived: React.PropTypes.bool,
  idx: React.PropTypes.number,
  fromType: React.PropTypes.string,
  toType: React.PropTypes.string,
  product: React.PropTypes.object,
  alterProduct: React.PropTypes.func,
  handleFormChanged: React.PropTypes.func,
  viewMode: React.PropTypes.bool,
  productIdx: React.PropTypes.number,
  linkExisting: React.PropTypes.func,
  linkDealsList: React.PropTypes.object,
  fromTypeList: React.PropTypes.object,
  linkTransportList: React.PropTypes.object,
  dealIdx: React.PropTypes.number,
  disabled: React.PropTypes.bool,
  isLast: React.PropTypes.bool,
  id: React.PropTypes.string,
  expensestypes: React.PropTypes.object,
  removeDealBulkExpense: React.PropTypes.func,
  files: React.PropTypes.object,
  transport: React.PropTypes.object,
  deleteFile: React.PropTypes.func,
  fromMultiNodal: React.PropTypes.bool,
};

export default connect(
  (state, props) => ({
    product: props.product
      ? props.product
      : state.getIn(['data', 'deals', 'deal', 'products', props.productIdx], new Map()),
    fromTypeList: state.getIn(['data', 'deals', 'list', props.fromType]),
    linkDealsList: state.getIn(['data', 'deals', 'list', props.toType]),
    linkTransportList: state.getIn(['data', 'deals', 'list', 'transport']),
    isArchived: state.getIn(['data', 'deals', 'deal', 'isArchived']),
    expensestypes: state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List()),
    files: state.getIn(['data', 'deals', 'files', 'USUAL'], new List()),
  }),
  (dispatch, props) => ({
    alterProduct(data) {
      alterProduct(dispatch, props.productIdx, data);
    },
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
    linkExisting() {
      linkExisting(dispatch, props.productIdx, props.idx);
    },
    removeDealBulkExpense(productIdx, expenseId) {
      removeDealExpense(dispatch, productIdx, expenseId);
    },
    deleteFile(uuid, idx) {
      deleteFile(dispatch, 'USUAL', uuid, idx);
    },
  })
)(Link);
